<template>
  <div class="w-full py-5">
    <div class="w-full max-w-7xl px-5 lg:px-0 mx-auto">
      <div class="flex flex-col gap-1">
        <div class="title-admission">
          <h2
            class="text-[21px] lg:text-3xl bg-[#f8f8f8] text-[#001c54] font-semibold capitalize text-center px-4"
          >
            ADMISSION PROCESS
          </h2>
        </div>
        <p class="text-[18px] text-[#001c54]">
          Applying for our online degree programs has never been simpler -
          follow these steps!
        </p>
      </div>
      <div class="pt-2">
        <div class="slick_admission_lp w-full">
          <div class="w-[30%] flex items-center">
            <div class="relative">
              <img
                src="@/assets/LPnew/images/left_arrow.png"
                alt="left arrow"
                class=""
              />
              <div class="absolute left-12 top-0 h-full">
                <div class="!flex !items-center h-full gap-2">
                  <h2 class="text-3xl text-[#234192] font-bold">01</h2>
                  <h2 class="font-bold text-xl text-[#121575] text-left px-2">
                    Submit Application
                  </h2>
                  <p class="text-md text-left font-bold">
                    Click here to visit the JAIN Online enrollment form
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-[30%] flex items-center">
            <div class="relative">
              <img
                src="@/assets/LPnew/images/left_arrow.png"
                alt="left arrow"
                class=""
              />
              <div class="absolute left-12 top-0 h-full">
                <div class="flex items-center gap-2 h-full">
                  <h2 class="text-3xl text-[#234192] font-bold">02</h2>
                  <h2 class="font-bold text-xl text-[#121575] text-left px-2">
                    Enroll for the elective
                  </h2>
                  <p class="text-md text-left font-bold">
                    Sign up and complete the 4 essential steps to enroll in the
                    program of your choice
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-[30%] flex items-center">
            <div class="relative">
              <img
                src="@/assets/LPnew/images/left_arrow.png"
                alt="left arrow"
                class=""
              />
              <div class="absolute left-12 top-0 h-full">
                <div class="flex items-center gap-2 h-full">
                  <h2 class="text-3xl text-[#234192] font-bold">03</h2>
                  <h2 class="font-bold text-xl text-[#121575] text-left px-2">
                    Make Payment
                  </h2>
                  <p class="text-md text-left font-bold">
                    Pay fees through Net banking/Debit card/Credit card or using
                    easy EMI with 0% interest
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "AdmissionView",
  beforeMount() {
    const elementToRemoveDes = document.querySelector(".slick_admission_lp");

    if (elementToRemoveDes) {
      elementToRemoveDes.remove();
    }
  },
  mounted() {
    $(`.slick_admission_lp`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slick-dots",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style></style>
